import { render } from "./MegaCell.vue?vue&type=template&id=10fac362"
import script from "./MegaCell.vue?vue&type=script&lang=js"
export * from "./MegaCell.vue?vue&type=script&lang=js"

import "./MegaCell.vue?vue&type=style&index=0&id=10fac362&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__